const arauModal = (() => {
  const pageArau = (document.getElementById("pageArau") != null);
  if (pageArau) {



    let secBnr = document.querySelector('#jsSecBnr');
    let modalWrap = secBnr.querySelector('.js-modal-wrap');
    let video = modalWrap.querySelector('video');

    MicroModal.init({
      disableScroll: true,
      // awaitOpenAnimation: true,
      // awaitCloseAnimation: true,
      // disableFocus: true,

      onShow: modal => {
        video.play()
      },
      onClose: modal => {
        video.pause()
      },
    });



  }
})()
export default arauModal;